import $ from "jquery";
import Drupal from "Drupal";
import drupalSettings from "drupalSettings";

(function ($, Drupal, drupalSettings) {
  "use strict";

  Drupal.behaviors.governance_documents_filter = {

    setdocumentdatefilters:function(form){
        var year = $(form).find('[name=year_select]').val();
        var minmonth = '01';
        var maxmonth = '12';

        if(year != 'all')
        {

            var minddate = year + '-' + minmonth + '-' + '01';
            var maxddate = year + '-' + maxmonth + '-' + '31';

            $(form).find('[name="field_publish_date_value[min]"]').val(minddate);
            $(form).find('[name="field_publish_date_value[max]"]').val(maxddate);
        }
        else
        {
            $(form).find('[name="field_publish_date_value[min]"]').val("");
            $(form).find('[name="field_publish_date_value[max]"]').val("");
        }

    },

    submitform: function(form){
        $(form).find(".button").click();

    },


    attach: function (context, settings) {


      once("governancedocumentform", "#views-exposed-form-document-listing-governance-documents", context).forEach(function (form) {


            $(form).find('[name=year_select]').change(function(){
                Drupal.behaviors.governance_documents_filter.setdocumentdatefilters(form);
                Drupal.behaviors.governance_documents_filter.submitform(form);
            });

             $(form).find('.form-select').change(function(){

                    Drupal.behaviors.governance_documents_filter.submitform(form);

              })


      });

    },
  };
})(jQuery, Drupal, drupalSettings);
